import axiosInstance from "../axiosInstance/axiosInstance";
import queryClient from "./queryClient";

// Serving hours barely move, but a hotel that has just changed them should not
// be stale for long.
const HOTEL_STALE_TIME = 60 * 1000;

export const loadHotel = (hotelId) => queryClient.fetchQuery({
    queryKey: ["hotel", hotelId],
    queryFn: async () => {
        const response = await axiosInstance.get(`/api/v1/hotels/${hotelId}`);
        return response.data?.data || response.data;
    },
    staleTime: HOTEL_STALE_TIME,
    retry: false,
});

// "HH:MM" as minutes past midnight, or null when unset/unparseable.
const toMinutes = (value) => {
    const match = /^(\d{1,2}):(\d{2})$/.exec(String(value || "").trim());
    if (!match) {
        return null;
    }
    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    if (hours > 23 || minutes > 59) {
        return null;
    }
    return hours * 60 + minutes;
};

// A hotel that has not set both ends is treated as always serving. Windows that
// run past midnight (e.g. 08:00 to 02:00) wrap, so the check flips to "outside
// the closed stretch" rather than a plain range test.
export const isWithinServingHours = (startTime, endTime, now = new Date()) => {
    const start = toMinutes(startTime);
    const end = toMinutes(endTime);

    if (start === null || end === null || start === end) {
        return true;
    }

    const current = now.getHours() * 60 + now.getMinutes();

    if (start < end) {
        return current >= start && current < end;
    }

    return current >= start || current < end;
};

// 24h "HH:MM" as the 12h label the guest reads on the banner.
export const formatServingTime = (value) => {
    const minutes = toMinutes(value);
    if (minutes === null) {
        return "";
    }
    const hours = Math.floor(minutes / 60);
    const suffix = hours < 12 ? "AM" : "PM";
    const hour12 = hours % 12 === 0 ? 12 : hours % 12;
    return `${hour12}:${String(minutes % 60).padStart(2, "0")} ${suffix}`;
};
